
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManageDepartmentsService {

  constructor(private api: ApiService) { }

  getAllDepartment(data: any): Observable<any> {
    return this.api.post(environment.getAllDepartment, data);
  }

  createDepartment(data: any): Observable<any> {
    return this.api.post(environment.createDepartment, data);
  }

  updateDepartment(data: any): Observable<any> {
    return this.api.post(environment.updateDepartment, data);
  }

  deleteDepartment(data: any): Observable<any> {
    return this.api.post(environment.deleteDepartment, data);
  }
}
